export const properties = [
  {
    id: 1,
    clientName: { pt: 'Shell Brasil', en: 'Shell Brazil' },
    clientSegment: { pt: "Energia", en: "Energy" },
    clientColor: "#FBCE07",
    clientLogo: "/landings/assets/images/cases/shell/logo.svg",
    caseImg: "/landings/assets/images/cases/shell/case.png",
    backgroundImg: "/landings/assets/images/cases/shell/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A Shell, líder em energia, conta com o apoio da Verzel e Embarkey para gerenciar e monitorar logisticamente suas cargas de óleo em todo o Brasil.",
      en: "Shell, a leader in energy, relies on Verzel and Embarkey to manage and monitor its oil shipments throughout Brazil."
    },
    description: {
      pt: "A Shell é uma das maiores empresas de energia do mundo, <b>comprometida com a inovação</b> e sustentabilidade. No Brasil, a Shell encontrou na Verzel e na Embarkey parceiros estratégicos para o desenvolvimento digital. A colaboração resultou na construção de uma plataforma robusta para o gerenciamento e monitoramento logístico de todas as cargas de óleo e embalado em todo o país. Este suporte foi essencial para otimizar operações, garantir eficiência e manter a liderança da Shell no mercado energético.",
      en: "Shell is one of the world's largest energy companies, <b>committed to innovation</b> and sustainability. In Brazil, Shell found strategic partners in Verzel and Embarkey for digital development. The collaboration resulted in the construction of a robust platform for managing and monitoring all oil and packaged shipments throughout the country. This support was essential for optimizing operations, ensuring efficiency, and maintaining Shell's leadership in the energy market."
    },
    data: [
      {
        number: '+4M',
        text: { pt: 'Litros de óleo transportado pela solução.', en: 'Liters of oil transported by the solution.' }
      },
      {
        number: '90%',
        text: { pt: 'Eficiência operacional dentro dos parâmetros internos.', en: 'Operational efficiency within internal parameters.' }
      },
      {
        number: '120k',
        text: { pt: 'Ordens de serviços gerenciadas pela plataforma.', en: 'Service orders managed by the platform.' }
      }
    ]
  },
  {
    id: 2,
    clientName: { pt: 'Mutant', en: 'Mutant' },
    clientSegment: { pt: "Experiência do cliente", en: "Customer Experience" },
    clientColor: "#9E37E2",
    clientLogo: "/landings/assets/images/cases/mutant/logo.svg",
    caseImg: "/landings/assets/images/cases/mutant/case.png",
    backgroundImg: "/landings/assets/images/cases/mutant/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A Mutant transforma a experiência do cliente com soluções inovadoras, com a Verzel ao lado no desenvolvimento de software e na alocação de talentos especializados.",
      en: "Mutant transforms customer experience with innovative solutions, with Verzel at its side in software development and specialized talent allocation."
    },
    description: {
      pt: "A Mutant é <b>líder em transformar a experiência do cliente</b>, combinando tecnologia e estratégia para impulsionar negócios. Com o apoio crucial da Verzel, a Mutant aprimorou suas soluções através do Desenvolvimento Digital, proporcionando um desenvolvimento de software robusto, e do Hub de Talentos, garantindo a alocação de profissionais especializados. A colaboração com a Verzel foi fundamental para o sucesso das plataformas de multi chat no WhatsApp e vocalização para URA, otimizando a comunicação e a eficiência operacional.",
      en: "Mutant is a <b>leader in transforming the customer experience</b>, combining technology and strategy to drive business. With crucial support from Verzel, Mutant enhanced its solutions through Digital Development, providing robust software development, and the Talent Hub, ensuring the allocation of specialized professionals. The collaboration with Verzel was essential for the success of multi-chat platforms on WhatsApp and IVR vocalization, optimizing communication and operational efficiency."
    },
    data: [
      {
        number: '+15',
        text: { pt: 'Países confiam em suas soluções', en: 'Countries trust their solutions' }
      },
      {
        number: '+10M',
        text: { pt: 'De chamados gerenciados via plataformas de atendimento mensalmente', en: 'Service calls managed via platforms monthly' }
      },
      {
        number: '+10',
        text: { pt: 'Soluções concebidas com apoio da aliança digital', en: 'Solutions conceived with support from the digital alliance' }
      }
    ]
  },
  {
    id: 3,
    clientName: { pt: 'BR COM', en: 'BR COM' },
    clientSegment: { pt: "Logística inteligente", en: "Smart Logistics" },
    clientColor: "#409E6A",
    clientLogo: "/landings/assets/images/cases/brcom/logo.svg",
    caseImg: "/landings/assets/images/cases/brcom/case.png",
    backgroundImg: "/landings/assets/images/cases/brcom/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A BRCom, especialista em logística inteligente, oferece soluções ponta a ponta aos seus clientes. A Verzel é sua parceira de tecnologia desde a fundação, responsável por todo o ecossistema digital da operação.",
      en: "BRCom, a smart-logistics specialist, delivers end-to-end solutions to its clients. Verzel has been its technology partner since day one, responsible for the operation's entire digital ecosystem."
    },
    description: {
      pt: "A BRCom é uma empresa de logística <b>dedicada a oferecer soluções inovadoras</b> que permitem às empresas focarem em suas vendas, confiando toda a logística à BRCom. Desde sua fundação, a Verzel desempenhou um papel crucial no desenvolvimento e na aliança tecnológica da BRCom, atendendo todas as suas necessidades de TI. Essa parceria permitiu à BRCom oferecer uma solução de logística eficiente e com pouco atrito para os vendedores, garantindo um crescimento sustentável e a liderança no mercado.",
      en: "BRCom is a logistics company <b>dedicated to offering innovative solutions</b> that allow companies to focus on their sales, entrusting all logistics to BRCom. Since its foundation, Verzel has played a crucial role in the development and technological alliance of BRCom, meeting all its IT needs. This partnership allowed BRCom to offer an efficient and low-friction logistics solution for sellers, ensuring sustainable growth and market leadership."
    },
    data: [
      {
        number: 'Milhão',
        text: { pt: 'Do zero ao primeiro milhão, com a Verzel ao lado desde o começo', en: 'From zero to the first million, with Verzel on board from day one' }
      },
      {
        number: '+11M',
        text: { pt: 'Cotações registradas na plataforma', en: 'Quotations registered on the platform' }
      },
      {
        number: '100%',
        text: { pt: 'Da operação digital construída pela Verzel', en: 'Of the digital operation built by Verzel' }
      }
    ]
  },
  {
    id: 4,
    clientName: { pt: 'Zignet', en: 'Zignet' },
    clientSegment: { pt: "Instituição Financeira", en: "Financial Institution" },
    clientColor: "#F58220",
    clientLogo: "/landings/assets/images/cases/zignet/logo.svg",
    caseImg: "/landings/assets/images/cases/zignet/case.png",
    backgroundImg: "/landings/assets/images/cases/zignet/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A Zignet simplifica a gestão de débitos veiculares com portal e aplicativo próprios. Com a automação construída pela Verzel, processa mais de 100 mil consultas por mês.",
      en: "Zignet simplifies vehicle debt management with its own portal and app. With automation built by Verzel, it processes over 100 thousand queries per month."
    },
    description: {
      pt: "A Zignet é uma empresa focada em <b>simplificar a gestão de débitos</b> veiculares, oferecendo um portal e um aplicativo intuitivos para consultas e pagamentos. Desde a sua criação, a Verzel desempenhou um papel essencial no desenvolvimento dessas plataformas, garantindo soluções tecnológicas avançadas e eficientes. A parceria com a Verzel permitiu à Zignet oferecer serviços confiáveis e de alta qualidade, atendendo às necessidades dos usuários e solidificando sua posição no mercado.",
      en: "Zignet is a company focused on <b>simplifying vehicle debt management</b>, offering an intuitive portal and app for consultations and payments. Since its creation, Verzel has played an essential role in the development of these platforms, ensuring advanced and efficient technological solutions. The partnership with Verzel allowed Zignet to offer reliable and high-quality services, meeting user needs and solidifying its market position."
    },
    data: [
      {
        number: '+12M',
        text: { pt: 'De transações realizadas', en: 'Transactions carried out' }
      },
      {
        number: '+8M',
        text: { pt: 'Clientes atendidos em todo brasil', en: 'Customers served throughout Brazil' }
      },
      {
        number: '+1M',
        text: { pt: 'Veículos regularizados pela plataforma', en: 'Vehicles regularized through the platform' }
      }
    ]
  },
  {
    id: 5,
    clientName: { pt: 'Bunzl', en: 'Bunzl' },
    clientSegment: { pt: "Distribuição", en: "Distribution" },
    clientColor: "#74B943",
    clientLogo: "/landings/assets/images/cases/bunzl/logo.svg",
    caseImg: "/landings/assets/images/cases/bunzl/case.png",
    backgroundImg: "/landings/assets/images/cases/bunzl/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A Bunzl, líder global em distribuição, desenvolve soluções digitais como o MOB com profissionais Verzel alocados em seu time, garantindo excelência de serviço aos seus clientes.",
      en: "Bunzl, a global leader in distribution, builds digital solutions such as MOB with Verzel professionals allocated to its team, ensuring service excellence for its clients."
    },
    description: {
      pt: "A Bunzl é uma empresa global líder em distribuição e serviços, oferecendo uma vasta gama de produtos essenciais para diversos setores. A Verzel tem um papel crucial como braço tecnológico da Bunzl, mantendo, criando e inovando em soluções digitais para seus clientes. Um exemplo destacado dessa colaboração é a MOB Soluções Digitais, que inclui sistemas avançados de controle de EPI e biometria, garantindo que a Bunzl continue a oferecer serviços de alta qualidade e inovação tecnológica.",
      en: "Bunzl is a global leader in distribution and services, offering a wide range of essential products for various sectors. Verzel plays a crucial role as Bunzl's technological arm, maintaining, creating, and innovating digital solutions for its clients. A highlighted example of this collaboration is MOB Digital Solutions, which includes advanced PPE control and biometric systems, ensuring Bunzl continues to offer high-quality services and technological innovation."
    },
    data: [
      {
        number: '18%',
        text: { pt: 'Redução de produção de carbono desde 2019', en: 'Reduction in carbon production since 2019' }
      },
      {
        number: '96%',
        text: { pt: 'Dos nossos insumos hoje são através de fornecedores locais', en: 'Of our inputs today are sourced from local suppliers' }
      },
      {
        number: '85%',
        text: { pt: 'Da cadeia de produção feitos de materiais sustentáveis', en: 'Of the production chain made from sustainable materials' }
      }
    ]
  },
  {
    id: 6,
    clientName: { pt: 'Grupo Avenida', en: 'Avenida Group' },
    clientSegment: { pt: "Varejo", en: "Retail" },
    clientColor: "#FFCE1C",
    clientLogo: "/landings/assets/images/cases/gav/logo.svg",
    caseImg: "/landings/assets/images/cases/gav/case.png",
    backgroundImg: "/landings/assets/images/cases/gav/background.png",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "O Grupo Avenida, referência em moda acessível, acelerou sua operação de crédito com a automação de reativação desenvolvida pela Verzel.",
      en: "Grupo Avenida, a reference in affordable fashion, accelerated its credit operation with the reactivation automation built by Verzel."
    },
    description: {
      pt: "O Grupo Avenida é uma das <b>maiores redes de varejo de moda</b> no Brasil, conhecida por oferecer produtos acessíveis e de qualidade. A Verzel é uma aliança tecnológica fundamental para o Grupo Avenida, apoiando todas as demandas de desenvolvimento, infraestrutura e alocação de recursos. Esta parceria tecnológica permite ao Grupo Avenida manter sua eficiência operacional, inovar continuamente e proporcionar uma excelente experiência de compra aos seus clientes.",
      en: "Grupo Avenida is one of the <b>largest fashion retail chains</b> in Brazil, known for offering affordable and quality products. Verzel is a fundamental technological ally for Grupo Avenida, supporting all development, infrastructure, and resource allocation demands. This technological partnership allows Grupo Avenida to maintain operational efficiency, continually innovate, and provide an excellent shopping experience to its customers."
    },
    data: [
      {
        number: '+200',
        text: { pt: 'Lojas abertas até o final de 2024', en: 'Stores open by the end of 2024' }
      },
      {
        number: '100%',
        text: { pt: 'De lojas migradas para o novo sistema', en: 'Of stores migrated to the new system' }
      },
      {
        number: '30M',
        text: { pt: 'De faturamento no varejo diariamente', en: 'Daily retail revenue' }
      }
    ]
  },
  {
    id: 7,
    clientName: { pt: 'AON', en: 'AON' },
    clientSegment: { pt: "Gestão de Risco", en: "Risk Management" },
    clientColor: "#EB0017",
    clientLogo: "/landings/assets/images/cases/aon/logo.svg",
    backgroundImg: "/landings/assets/images/cases/aon/background.png",
    caseImg: "/landings/assets/images/cases/aon/case.jpg",
    principalImg: "/landings/assets/images/checkered.png",
    disclaimer: {
      pt: "A Aon, líder em gestão de riscos e seguros, avança no mercado com o apoio do Digital Advisor da Verzel, impulsionando soluções inovadoras.",
      en: "Aon, a leader in risk management and insurance, advances in the market with the support of Verzel's Digital Advisor, driving innovative solutions."
    },
    description: {
      pt: "A Aon é uma empresa global de gestão de riscos, seguros e consultoria que oferece soluções integradas para proteger e potencializar o crescimento dos seus clientes. Com o apoio da Verzel, a Aon implementou o Digital Advisor, uma ferramenta essencial para idear e desenvolver soluções digitais inovadoras. Este suporte foi crucial para identificar e aplicar inovações nas principais áreas da empresa, garantindo que a Aon se mantenha na vanguarda do mercado e continue a crescer e manter seus clientes.",
      en: "Aon is a global risk management, insurance, and consulting company offering integrated solutions to protect and enhance client growth. With support from Verzel, Aon implemented the Digital Advisor, an essential tool for devising and developing innovative digital solutions. This support was crucial for identifying and applying innovations in key areas of the company, ensuring that Aon stays at the forefront of the market and continues to grow and retain its clients."
    },
    data: [
      {
        number: '50k',
        text: { pt: 'Colaboradores ao redor do mundo', en: 'Employees around the world' }
      },
      {
        number: '+120',
        text: { pt: 'Países que contam com sua gestão', en: 'Countries relying on its management' }
      },
      {
        number: '92%',
        text: { pt: 'Empresas do setor adotaram sua metodologia', en: 'Of companies in the sector have adopted its methodology' }
      }
    ]
  }
];